(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cope-legami-halloween"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cope-halloween')) {
    customElements.define('cope-halloween', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        const track = this.querySelector('.cope-hw__track');
        const arrows = this.querySelector('.cope-hw__arrows');
        if (!track || !arrows) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const buttons = [...arrows.querySelectorAll('button')];
        const update = () => {
          const overflow = track.scrollWidth > track.clientWidth + 2;
          arrows.hidden = !overflow;
          const rtl = getComputedStyle(track).direction === 'rtl';
          const position = rtl ? -track.scrollLeft : track.scrollLeft;
          buttons[0].disabled = position <= 2;
          buttons[1].disabled = position >= track.scrollWidth - track.clientWidth - 2;
        };
        buttons.forEach(button => button.addEventListener('click', () => {
          const card = track.firstElementChild;
          const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
          const direction = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
          track.scrollBy({ left: Number(button.dataset.direction) * step * direction, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }, options));
        track.addEventListener('scroll', update, { ...options, passive: true });
        this.observer = new ResizeObserver(update);
        this.observer.observe(track);
        update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
